package top.wcpe.allincore.dsl.ir.model.internal

/**
 * 只读 List 视图（模块内共享工具）。
 *
 * 复刻原 Java `Collections.unmodifiableList(new ArrayList<>(...))` 语义：
 * - **保序**：委托构造期传入的 [backing]（约定为 ArrayList），迭代顺序即插入序。
 * - **只读**：继承 Kotlin [AbstractList]（只暴露只读契约、不实现可变方法），
 *   Java 侧对其调用 add / remove / clear 等会抛 [UnsupportedOperationException]，
 *   Java 调用方无法借 getter 返回值篡改 IR 内部状态。
 *
 * equals / hashCode / toString 均委托 [backing]，与所包裹 List 完全一致。
 *
 * commonMain 无 `java.util.Collections`，故用本类等价替代，`internal` 仅限 dsl-ir 内部使用。
 *
 * @param backing 已在构造方保序拷贝好的底层 List（本类不再拷贝，调用方负责传入独立副本）。
 */
internal class ReadOnlyList<E>(
    private val backing: List<E>,
) : AbstractList<E>() {

    override val size: Int
        get() = backing.size

    override fun get(index: Int): E = backing[index]
}
